import { sendPost } from "src/utils/sendApi";

export const proceduresUploadFileApi = sendPost("v1/data/freepage/upload/file");

export const proceduresRetrieveApi = sendPost("v1/data/freepage/retrieve");

export const procedureDeleteApi = sendPost("v1/data/freepage/delete/file");
